define('components/photoset/layouts/fitColumn/row', [
    'components/photoset/layouts/base/row',
    'components/photoset/layouts/fitColumn/column'
], function (Base, Column) {
    var threshold = 1.25;

    function Model(jsonModel) {
        Base.call(this, jsonModel);

        this.columns = ko.pureComputed(this._getColumns.bind(this, jsonModel.columnsCount));

        this.items = this.columns.reduce(function (result, column) { return result.concat(column.items()) }, () => []);
        this.relWidth = this.columns.reduce(function (value, column) { return value + column.relWidth() }, () => 0);

        this.offset = ko.observable(jsonModel.offset).unwrap();

        this.height = this.columns
            .pluck('height')
            .max(function (height) { return height.getModule() });
    }

    Model.prototype = Object.create(Base.prototype);
    Model.prototype.constructor = Model;

    Model.prototype.append = function (item) {
        this._append(item, this.columns());
    };

    Model.prototype.prepend = function (item) {
        var items = [item].concat(this.items());

        _(this.columns()).invoke('clear');
        _(items).each(this.append.bind(this));
    };

    Model.prototype.pop = function () {
        var item = _(this.items()).last();

        if (item != null) {
            _(this.columns()).each(function (column) { column.remove(item) });
            return item;
        }

        return null;
    };

    Model.prototype.compact = function () {
        var items = _(this.items()).sortBy(function (item) { return item.index() }),
            columns = this.columns(),
            columnsCount = this._getColumnsCountToFitItems(items),
            pickedColumns = columns.slice(0, columnsCount);

        if (columnsCount < columns.length) {
            _(columns).invoke('clear');
            _(items).each(function (item) { this._append(item, pickedColumns) }, this);
        }
    };

    Model.prototype.clear = function () {
        _(this.columns()).invoke('clear');
    };

    Model.prototype.canAdd = function (item) {
        return this._canAdd(item, this.columns());
    };

    Model.prototype._updateItemsVisibility = function (value) {
        this.items().forEach(item => item.isVisible(value));
    }

    Model.prototype._getColumns = function (count) {
        return _.generate(count, function () { return new Column({ offset: this.offset }) }.bind(this));
    };

    Model.prototype._append = function (item, columns) {
        var column = _.chain(columns)
            .sortBy(function (column) { return column.relHeight() })
            .first()
            .value();

        if (column != null)
            column.add(item);
    };

    Model.prototype._canAdd = function (item, columns) {
        var hasFirstLine = _(columns).all(function (column) { return !column.isEmpty() });

        if (hasFirstLine) {
            var maxHeight = _.chain(columns)
                .map(function (column) { return column.items()[0] })
                .map(function (item) { return item.relHeight() })
                .max()
                .value() * threshold;

            return _(columns).any(function (column) { return column.relHeight() + item.relHeight() <= maxHeight });
        }

        return true;
    };

    Model.prototype._getColumnsCountToFitItems = function (items) {
        var result = this.columns().length,
            count = this.columns().length - 1,
            canFit = true,
            columns;

        while (canFit) {
            columns = this._getColumns(count);

            canFit = _(items).all(function (item) {
                var canAdd = this._canAdd(item, columns);

                if (canAdd)
                    this._append(item, columns);

                return canAdd;
            }.bind(this));

            if (canFit) {
                result = count;
                count--;
            }
        }

        return result;
    };

    return Model;
});